import React, { Component } from 'react';
import './App.css';
import Header from './components/header';
import Landing from './components/landing';
import About from './components/about';
import Services from './components/services';
import Clients from './components/clients';
import Bio from './components/bio';
import Contact from './components/contact';
import Testimonial from './components/testimonial';
import Footer from './components/footer';
import Prismic from 'prismic-javascript';

class App extends Component {
    prismicContent = [];

    constructor(props) {
        super(props);
        this.detectLang();
        this.fetchDatas();
    }

    componentWillReceiveProps(nextProps) {
        this.detectLang(nextProps);
        this.fetchDatas();
    }

    detectLang(props = this.props) {
        switch (props.match.params.lang) {
            case 'fr':
                return 'fr-be';
            case 'nl':
                return 'nl-be';
            case 'en':
                return 'en-gb';
            default:
                let language = navigator.languages && navigator.languages[0] ||
                    navigator.language ||
                    navigator.userLanguage;

                if (language.includes('nl')) {
                    return 'nl-be';
                } else if (language.includes('en')) {
                    return 'en-gb';
                } else {
                    return 'fr-be';
                }
        }
    }

    fetchDatas() {
        Prismic.api("https://erudis.cdn.prismic.io/api/v2", {
            accessToken: 'MC5YMFpPb2hFQUFDTUFmaHRZ.77-9Sknvv71C77-9PRjvv71PO--_ve-_ve-_vXLvv73vv73vv71N77-977-977-977-977-9Ae-_vVddKO-_ve-_vXg'
        }).then((api) => {
            return api.query('', { lang: this.detectLang() });
        }).then((response) => {
            this.prismicContent = response.results;
            //console.log(this.prismicContent);
            this.forceUpdate();
        }, (err) => {
            console.log("Something went wrong: ", err);
        });
    }

    render() {
        return (
            <div className="app" ref={(el) => { this._app = el }} >
                <Header lang={this.detectLang()} content={this.prismicContent} />
                <Landing autoStart={false} content={this.prismicContent.find(e => { return e.type === 'header' })} />
                <About content={this.prismicContent.find(e => { return e.type === 'about' })} offsets={-150} />
                <Services content={this.prismicContent.find(e => { return e.type === 'services' })} offsets={-200} lang={this.detectLang()} />
                <Testimonial content={this.prismicContent.find(e => { return e.type === 'testimonials' })} offsets={-200} lang={this.detectLang()} />                
                <Clients content={this.prismicContent.find(e => { return e.type === 'clients' })} offsets={-150} lang={this.detectLang()} />
                <Bio content={this.prismicContent.find(e => { return e.type === 'didierdegreef' })} offsets={-150} />
                <Contact offsets={-150} />
                <Footer content={this.prismicContent.find(e => { return e.type === 'footer' })} />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js